module.exports = __webpack_public_path__ + "static/img/cancer_icon-39.c4ceeea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cancerrealtime/cancer_icon-39.png
// module id = haZ7
// module chunks = 0